<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    title?: string;
    eyebrow?: string;
    class?: string;
    as?: "section" | "div" | "article";
    headerActions?: Snippet;
    children?: Snippet;
  }

  const {
    title,
    eyebrow,
    class: extraClass = "",
    as = "section",
    headerActions,
    children,
  }: Props = $props();
</script>

<svelte:element this={as} class="panel-card {extraClass}">
  {#if title || eyebrow || headerActions}
    <header class="panel-heading">
      <div>
        {#if eyebrow}<p class="eyebrow">{eyebrow}</p>{/if}
        {#if title}<h2>{title}</h2>{/if}
      </div>
      {#if headerActions}
        <div class="card-header-actions">
          {@render headerActions()}
        </div>
      {/if}
    </header>
  {/if}
  {@render children?.()}
</svelte:element>

<style>
  .card-header-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>
